(function($) {

/* Navigation Toggle
   ========================================================================== */

$(document).on('click', '#masthead .navigation-toggle', function(e) {
	e.preventDefault();
	$(this).toggleClass('navigation-toggle-active');
	$('#masthead .navigation-collapse').toggleClass('navigation-open');
});

/* Search Toggle
   ========================================================================== */

$(document).on('click', '#masthead .search-toggle', function(e) {
	e.preventDefault();
	$(this).toggleClass('search-toggle-active');
	$('#masthead .search-form').toggleClass('search-form-open');
	$('#masthead .search-form-input').focus();
});

$('body').click(function(e) {
	if ($('#masthead .search-form').hasClass('search-form-open')) {
		var target = $(e.target);
		if(!target.is('#masthead .search-form-input, #masthead .search-form-btn') ) {
			$('#masthead .search-toggle').toggleClass('search-toggle-active');
			$('#masthead .search-form').toggleClass('search-form-open');
		}
	}
});

/* Search Toggle
   ========================================================================== */

$(document).on('click', '.register-product-link', function(e) {
	e.preventDefault();
	$('.register-product').toggleClass('register-product-active');
});

$(document).ready(function ($) {

	/* HTML5 Placeholder
	   ========================================================================== */

	$('input, textarea').placeholder();

	/* Slider
	   ========================================================================== */

	$(".slides").slick();

	/* Tabset
	   ========================================================================== */

	var allTabLinks    = $('[data-tab]'),
		allTabContents = $('[data-content]');

	$(window).on('hashchange', function () {
		var hash = window.location.hash,
			matches = hash.match(/^#tab-(\d)-(\d)/);

		if (matches.length) {
			$('[data-tab-group=' + matches[1] + '][data-tab=' + matches[2] + ']').trigger('click');
		}
	});

	$('[data-tabset]').each(function () {
		var wrapper = $(this),
			group   = String(wrapper.data('tab-group')),
			scope = '[data-tab-group=' + group + ']',
			tabs    = allTabLinks.filter(scope),
			content = allTabContents.filter(scope),
			activeTab = 1;

		var initialHash = window.location.hash
			? window.location.hash.match(/^#tab-(\d)-(\d)/)
			: [];

		if (initialHash.length && initialHash[1] == group) {
			activeTab = initialHash[2];
		}

		tabs.filter("[data-tab='" + activeTab + "']").addClass('tab-link-active');
		content.filter("[data-content='" + activeTab + "']").addClass('tab-active');

		tabs.on('click', function (event) {
			var tab = $(this);

			activeTab = tab.data('tab');

			if (window.innerWidth < 1024) {
				tabs.filter("[data-tab="+ activeTab +"]")
					.toggleClass('tab-link-active');

				content.filter('[data-content=' + activeTab + ']')
					.toggle();
			} else {
				tabs.removeClass('tab-link-active')
					.filter("[data-tab="+ activeTab +"]")
						.addClass('tab-link-active');

				content.hide()
					.filter('[data-content=' + activeTab + ']')
					.show();
			}

			location.hash = '#tab-' + group + '-' + activeTab;

			$.fn.matchHeight._update();
			event.preventDefault();
		});

		$(window).on("load resize", function () {
			if (window.innerWidth > 767) {
				tabs
					.removeClass('tab-link-active')
					.filter("[data-tab="+ activeTab +"]").addClass('tab-link-active');

				content
					.hide()
					.filter('[data-content=' + activeTab + ']').show();
			}
		}).resize();

		/**
		 * Warning: if you have duplicate tabs for both horizontal and vertical tabs
		 * simultaneously, this will wrap navigation around from start to finish because:
		 *
		 *   - Tab 1
		 *   - Tab 2
		 *   - Tab 3
		 *   - Tab 1
		 *
		 * Click next, and Tab 3 will wrap to Tab 1 because the second set of tabs'
		 * Tab 1 is next.
		 */

		wrapper.on('click', '[data-tab-prev]' + scope, function (event) {
			for (var i = tabs.length - 1; i >= 0; i--) {
				var tab = tabs.eq(i);

				if (tab.is('.tab-link-active')) {
					if (i > 0) {
						// Only go to the previous tab so long as we aren't on the first tab
						tabs.eq(i - 1).trigger('click');
					}

					break;
				}
			}

			event.preventDefault();
		});

		wrapper.on('click', '[data-tab-next]' + scope, function (event) {
			for (var i = 0, last = tabs.length - 1; i < last; i++) {
				var tab = tabs.eq(i);

				if (tab.is('.tab-link-active')) {
					if (i < last) {
						// Only go to the next tab so long as we aren't on the last tab
						tabs.eq(i + 1).trigger('click');
					}

					break;
				}
			}

			event.preventDefault();
		});
	});

	/* Accordion
	   ========================================================================== */

	var accordion = '[data-accordion]',
		accordionHeader = '[data-accordion-header]',
		accordionContent = '[data-accordion-content]',
		accordionActiveClass = 'accordion-active';

	$(accordion)
	.find(accordionContent).hide().end()
	.find(accordionHeader +':first').addClass(accordionActiveClass).end()
	.find(accordionContent +':first').show().end()
	.on('click', accordionHeader, function (event) {
		var self = $(this),
			accordionBody = self.closest(accordion);

		if (!self.hasClass(accordionActiveClass)) {
			accordionBody
				.find(accordionHeader).removeClass(accordionActiveClass).end()
				.find(accordionContent).slideUp().end();

			self.addClass(accordionActiveClass)
				.next(accordionContent).slideDown(function(){
					$.fn.matchHeight._update();
				}).end();

		}

		event.preventDefault();

	});

	/* Gallery Shortcode Fancybox
	   ========================================================================== */

	$(".gallery-thumbnail a").attr("rel","gallery");
	$(".gallery a").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});

	/* ShareThis
	   ========================================================================== */
	$('a.st_sharethis_large').click(function(e){
	    e.preventDefault();
	});

	/* Distributor Registration
	   ========================================================================== */

    $('.registration-form')
    .on('change', '#user_login', function () {
        var username = $(this);
        username.data('overridden', this.value !== this.defaultValue && this.value !== '');
    })
    .on('input change', '#company_name', function (e) {
        var username = $('#user_login'),
            company  = $(this);

        if (!username.data('overridden')) {
            username.val(
                company.val()
                    .toLowerCase()
                    .replace(/[^0-9a-z ]/g, '')
                    .replace(/\s+|\-{2,}/g, '-')
            );
        }
    });

}); // end.ready

}(jQuery));
